import React from 'react'
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  MinusCircleOutlined,
  ExclamationOutlined
} from "@ant-design/icons";
import {Tag} from 'antd'
import { ValimateStep } from '../../autogenerated/models'

interface ExcutionStatusesProps {
  step: ValimateStep
}

const ExcutionStatusSelector: React.FC<ExcutionStatusesProps> = ({step}) => {


  switch(step.result) {
    case "pass":
      return <Tag icon={<CheckCircleOutlined />} color="success">Passed</Tag>
    case "fail":
      return <Tag icon={<CloseCircleOutlined />} color="error">Failed</Tag>
    case "cancelled":
      return <Tag icon={<ExclamationOutlined />} color="warning">Cancelled</Tag>
    default:
      return <Tag icon={<MinusCircleOutlined />} color="default">Inconclusive</Tag>
  }
}

export default ExcutionStatusSelector
